import React from 'react';
import App from './App';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { createUploadLink } from "apollo-upload-client";




const httpLink = createUploadLink({
 
  //uri:"http://localhost:4000/graphql",
 //uri:"https://silly-veil-crab.cyclic.app/graphql"
 uri:"https://pic-forest-backend.onrender.com/graphql"
});



const authLink = setContext(() => {
  const token = localStorage.getItem('jwtToken');
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    }
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  credentials: 'include'
});



export default (
  <ApolloProvider client={client}>
    <App />
    
  </ApolloProvider>
);
